import $ from 'jquery'
import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded from 'Imagesloaded'

export default {
  init() {
    
    const product = new Swiper('.product-swiper-container', {
      init: false,
      navigation: {
        nextEl: '.about-gallery-next',
        prevEl: '.about-gallery-prev',
      },
      loop: false,
      autoplay: {
        delay: 4000,
      },
      speed: 800,
      grabCursor: true,
      slidesPerView: 2,
      spaceBetween: 16,
      breakpoints: {
        992: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        },
      }
    });

    ImagesLoaded( '.product-swiper-container', ()=> {
      product.init()
    })

    const slide = new Swiper('.jwd-slide', {
      // init: false,
      pagination: {
        el: '.jwd-slide-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 4000,
      },
      speed: 400,
      effect: 'fade',
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
    })

    $('.view-plan').click(function(event) {

      $.magnificPopup.open({
        items: $(this).data('images'),
        type: 'image',
        gallery: {
          enabled: true
        },
      }, 0);

      event.preventDefault()
    })
    
  },
  finalize() {
  },
}